export default __webpack_public_path__ + "static/media/image-2.99c26a34.png";